<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>To the memory of a very special tree I knew, with curious leaves and scented roots</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?31768696